import { render, staticRenderFns } from "./BuildingSocietyIncorporationTask.vue?vue&type=template&id=5f515279&scoped=true&"
import script from "./BuildingSocietyIncorporationTask.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyIncorporationTask.vue?vue&type=script&lang=js&"
import style0 from "./BuildingSocietyIncorporationTask.vue?vue&type=style&index=0&id=5f515279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f515279",
  null
  
)

export default component.exports